import DeleteRequestAuthModal_vue_vue_type_script_setup_true_lang_default from "./DeleteRequestAuthModal.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/DeleteRequestAuthModal.vue
var DeleteRequestAuthModal_default = DeleteRequestAuthModal_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DeleteRequestAuthModal_default as default };

//# sourceMappingURL=DeleteRequestAuthModal.vue.js.map